<div class="bg-m0 flex max-h-[600px] select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="editPhotoDialogTitle"
    class="text-s2 mt-5 text-left text-2xl font-semibold"
    >Edit Photo</div
  >

  <div class="mt-6">
    <input
      autocomplete="off"
      spellcheck="false"
      type="file"
      (change)="fileChangeEvent($event)"
    />
  </div>

  <div class="mt-6 h-[200px]">
    <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      [containWithinAspectRatio]="false"
      [aspectRatio]="4 / 4"
      [roundCropper]="true"
      [canvasRotation]="0"
      [alignImage]="'left'"
      [resizeToWidth]="480"
      [style.display]="showCropper ? null : 'none'"
      output="base64"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady($event)"
      (loadImageFailed)="loadImageFailed()"
    ></image-cropper>
  </div>

  <div class="mt-6 h-20 w-20">
    <img *ngIf="croppedImage" class="rounded-full" [src]="croppedImage" />
  </div>

  <div class="mt-6">
    <button
      data-cy="editPhotoDialogSaveButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      (click)="save()"
      >Save</button
    >

    <button
      data-cy="editPhotoDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
